/* eslint-disable */
import get from 'lodash/get';
import createConsts from '../../utils/redux/consts';
import {
  createActions,
} from '../../utils/redux';

const supportedActions = [
  'UPDATE',
  'REMOVE'
];

export const consts = createConsts('context', 'permissions', ...supportedActions);
export const actions = createActions(consts);

// retrieved data
const user = window.storage.getItem('user');
const initialLoggedUser = user ? JSON.parse(user) : null;

const initialState = {
  loggedUserId: get(initialLoggedUser, 'id', null),
  targetUserId: null,
  caregiverCircles: null,
  isLoggedUser: false,
  isCaregiver: false,
  isVerifiedDependent: false,
  isFamilyMemberOnly: null,
  dependentsList: [],
};

const updatePermissions = (state, payload) => {
  const {
    loggedUserId: prevLoggedId,
    targetUserId: prevTargetId,
    caregiverCircles: prevCaregiverCircles,
    dependentsList: prevDependentsList,
  } = state;
  const {
    loggedUserId,
    targetUserId,
    caregiverCircles,
    targetUser,
    dependentsList,
  } = payload;

  const newLoggedUserId = loggedUserId || prevLoggedId;
  const newTargetUserId = targetUserId || prevTargetId;
  const newCaregiverCircles = caregiverCircles || prevCaregiverCircles;
  const newDependentsList = dependentsList || prevDependentsList;
  const isLoggedUser = newTargetUserId === newLoggedUserId;
  const isCaregiver = newCaregiverCircles && newCaregiverCircles.includes(newTargetUserId);
  const isVerifiedDependent = newDependentsList && newDependentsList.includes(newTargetUserId);
  const isFamilyMemberOnly = targetUser ? targetUser.actualFamilyMember : state.isFamilyMemberOnly;

  return {
    isFamilyMemberOnly,
    loggedUserId: newLoggedUserId,
    targetUserId: newTargetUserId,
    caregiverCircles: newCaregiverCircles,
    dependentsList: newDependentsList,
    isLoggedUser,
    isCaregiver,
    isVerifiedDependent,
  };
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case consts.UPDATE: return updatePermissions(state, payload);
    case consts.REMOVE: return { ...initialState, loggedUserId: null };
    default: return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/context/permissions.js